export default __webpack_public_path__ + "static/helintcase1-ed2709ad2b5dabf75a27d4c3746cec69.png";